import React, { Component } from 'react';
import axios from 'axios';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

const baseURL = "https://www.roadtonationals.com/api/women/attendanceteam";
const teamsURL = "https://www.roadtonationals.com/api/women/allteams";

class AttendanceTeam extends Component {
  constructor(props) {
    let columns = [
      {Header: 'Year', accessor: 'year'},
      {Header: 'Average', accessor: 'avg'},
      {Header: 'Maximum', accessor: 'max'},
      {Header: 'Total', accessor: 'total', Cell: props => <strong>{props.value}</strong>},
      {Header: 'Num Meets', accessor: 'count'},
    ];
    super(props);
    this.state = {
      cols: columns,
      teams: [],
      numRows: 0,
      data: [],
      teamFilter: 0,
      curPage: 1,
      yearFilter: 2017,
      ready: false
    };
    this.handleTeamChange = this.handleTeamChange.bind(this);
  }
  componentWillMount() {
    this.getTeams({
      "year": this.state.yearFilter
    });
  }
  getTeams(config) {
    var url = teamsURL + '/' + config.year;
    axios.get(url)
    .then(response => {
      if (!response.data){

      } else {
        this.setState({
          teams: response.data
        });
        if(localStorage.lastTeamID) {
          this.getResults({
            "team": Number(localStorage.lastTeamID)
          });
          this.setState({
            teamFilter : Number(localStorage.lastTeamID)
          });
        }
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }
  getResults(config) {
    var url = baseURL + '/' + config.team;
    axios.get(url)
    .then(response => {
      if (!response.data){

      } else {
        //console.log(response.data);
        let length = response.data.length;
        this.setState({
          data: response.data,
          numRows: length,
          ready: true
        });
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }
  defaultSortMethod(a, b) { //desc
    // force null and undefined to the bottom
    a = (a === null || a === undefined) ? -Infinity : a
    b = (b === null || b === undefined) ? -Infinity : b
    // force any string values to lowercase
    a = a === 'string' ? a.toLowerCase() : a
    b = b === 'string' ? b.toLowerCase() : b
    //account for commas in string number (ex: "12,000")
    if(typeof a === 'string' && !isNaN(parseFloat(a.replace(/,/g, '')))) {
        a = parseFloat(a.replace(/,/g, ''));
    }
    if(typeof b === 'string' && !isNaN(parseFloat(b.replace(/,/g, '')))) {
        b = parseFloat(b.replace(/,/g, ''));
    }
    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
      return -1
    }
    if (a < b) {
      return 1
    }
    // returning 0, undefined or any falsey value will use subsequent sorts or the index as a tiebreaker
    return 0
  }
  handleTeamChange(event) {
    this.getResults({
      "team": Number(event.currentTarget.value)
    });
    this.setState({
      teamFilter : Number(event.currentTarget.value)
    });
    localStorage.lastTeamID = event.currentTarget.value;
  }
  getTeamSelect() {
    const teams = this.state.teams.map((team) =>
      <option key={team.id} value={team.id}>{team.team_name}</option>
    );
    return <span className="small-12 columns no-margin"><select id="team_filter" value={this.state.teamFilter} onChange={this.handleTeamChange}>
      <option key="0" value="0">SELECT TEAM</option>
      {teams}
      </select></span>;
  }
  getTable() {
    if(this.state.ready === true){
      return <ReactTable
        className="-striped -highlight"
        data={this.state.data}
        columns={this.state.cols}
        defaultSortMethod={this.defaultSortMethod}
        showPagination={false}
        defaultPageSize={this.state.numRows}
        pageSize={this.state.numRows}
      />;
    } else {
      return <h4>Please select a team</h4>
    }
  }
  render() {
    return (
      <div>
        <div className="row">
          <div className="small-12 columns">
          {this.getTeamSelect()}
          </div>
        </div>
        <div className="row">
          <div className="small-12 columns">
            <div className="teamsbox">
              <div className="attendance-table">
                {this.getTable()}
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AttendanceTeam;



// WEBPACK FOOTER //
// ./src/components/attendance/AttendanceTeam.js